import { useAppContext } from "../appContext";
import { Element } from "react-scroll";
// Data
import { whitepaperData } from "../data";
// Components
import { Button, Col, Container, Row } from "react-bootstrap";
import { Title } from "./globalStyledComponents";
import StyledCardWhitepaper from "./StyledCardWhitepaper";

export default function Whitepapers() {
  const { theme } = useAppContext();

  return (
    <Element name={"Whitepapers"} id="whitepapers">
      <section className="section">
        <Container className="text-center">
          <Title>
            <h2>Whitepapers</h2>
            <div className="underline"></div>
          </Title>
          <Row xs={1} md={2} lg={3} className="g-4 justify-content-center row">
                {whitepaperData.map(function ({
                  id,
                  name,
                  date,
                  link
                }) {
                  return (
                    <Col key={id}>
                      <StyledCardWhitepaper
                        name={name}
                        date={date}
                        url={link}
                      />
                    </Col>
                  );
                })}
              </Row>
        </Container>
      </section>
    </Element>
  );
}
